import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { compactNavigation, defaultNavigation, futuristicNavigation, horizontalNavigation } from 'app/mock-api/common/navigation/data';
import { CommonDropdownService } from 'app/shared/services/CommonDropdown.service';

import { user } from '../user/data';

@Injectable({
    providedIn: 'root'
})
export class NavigationMockApi {
    private _compactNavigation: FuseNavigationItem[] = compactNavigation;
    private readonly _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
    private readonly _futuristicNavigation: FuseNavigationItem[] = futuristicNavigation;
    private readonly _horizontalNavigation: FuseNavigationItem[] = horizontalNavigation;

    private _compactNavigation_new: FuseNavigationItem[];
    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService, private _commonservice: CommonDropdownService) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {

        ;
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/common/navigation')
            .reply(() => {

                //alert("hello");

                ;

                // Fill compact navigation children using the default navigation
                this._compactNavigation.forEach((compactNavItem) => {

                    //console.log("compactNavItem.title", compactNavItem.title);

                    this._compactNavigation.forEach((defaultNavItem) => {
                        if ( defaultNavItem.id === compactNavItem.id )
                        {
                            //console.log("defaultNavItem.title", defaultNavItem.title);
                            compactNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // // Fill futuristic navigation children using the default navigation
                // this._futuristicNavigation.forEach((futuristicNavItem) => {
                //     this._defaultNavigation.forEach((defaultNavItem) => {
                //         if ( defaultNavItem.id === futuristicNavItem.id )
                //         {
                //             futuristicNavItem.children = cloneDeep(defaultNavItem.children);
                //         }
                //     });
                // });

                // Fill horizontal navigation children using the default navigation
                this._horizontalNavigation.forEach((horizontalNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if ( defaultNavItem.id === horizontalNavItem.id )
                        {
                            horizontalNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Return the response
                return [
                    200,
                    {
                        compact   : cloneDeep(this._compactNavigation),
                        default   : cloneDeep(this._defaultNavigation),
                        futuristic: cloneDeep(this._futuristicNavigation),
                        horizontal: cloneDeep(this._horizontalNavigation)
                    }
                ];
            });

        // this._commonservice.getUserRoleRightsMenu().subscribe(res => {


        //     //this._compactNavigation_new = res;
        //     this._compactNavigation = res;
            

        //     //console.log("result menu --> ", res);

        //     alert("hello");

        //     // res.forEach((res) => {

        //     //   // //console.log("compactNavItem.title", this._compactNavigation);

        //     //     res.forEach((defaultNavItem) => {
        //     //         if (res.children !== null) {
        //     //             //console.log("defaultNavItem.title", res.title);
        //     //             res.children = cloneDeep(res.children);
        //     //         }
        //     //     });
        //     // });

        //             this._compactNavigation.forEach((compactNavItem) => {

        //             //console.log("compactNavItem.title", compactNavItem.title);

        //             this._compactNavigation.forEach((defaultNavItem) => {
        //                 if ( defaultNavItem.id === compactNavItem.id )
        //                 {
        //                     //console.log("defaultNavItem.title", defaultNavItem.title);
        //                     compactNavItem.children = cloneDeep(defaultNavItem.children);
        //                 }
        //             });
        //         });
        //     // // Fill futuristic navigation children using the default navigation
        //     // this._futuristicNavigation.forEach((futuristicNavItem) => {
        //     //     this._defaultNavigation.forEach((res) => {
        //     //         if (res.id === futuristicNavItem.id) {
        //     //             futuristicNavItem.children = cloneDeep(res.children);
        //     //         }
        //     //     });
        //     // });

        //     // // Fill horizontal navigation children using the default navigation
        //     // this._horizontalNavigation.forEach((horizontalNavItem) => {
        //     //     this._defaultNavigation.forEach((res) => {
        //     //         if (res.id === horizontalNavItem.id) {
        //     //             horizontalNavItem.children = cloneDeep(res.children);
        //     //         }
        //     //     });
        //     // });

        //     // Return the response
        //     return [
        //         200,
        //         {
        //             compact: cloneDeep(this._compactNavigation),
        //             default: cloneDeep(this._defaultNavigation),
        //             futuristic: cloneDeep(this._futuristicNavigation),
        //             horizontal: cloneDeep(this._horizontalNavigation)
        //         }
        //     ];
        // });


        //   },
        //     (error) => {
        //       console.log(error);

        //     }
        //   );


        //  this._fuseMockApiService
        // .onGet('api/common/navigation')
        // .reply(() => {

        //     alert("hello");

        //     ;

        //     // Fill compact navigation children using the default navigation
        //     this._compactNavigation.forEach((compactNavItem) => {

        //         //console.log("compactNavItem.title", compactNavItem.title);

        //         this._compactNavigation.forEach((defaultNavItem) => {
        //             if ( defaultNavItem.id === compactNavItem.id )
        //             {
        //                 //console.log("defaultNavItem.title", defaultNavItem.title);
        //                 compactNavItem.children = cloneDeep(defaultNavItem.children);
        //             }
        //         });
        //     });

        //     // // Fill futuristic navigation children using the default navigation
        //     // this._futuristicNavigation.forEach((futuristicNavItem) => {
        //     //     this._defaultNavigation.forEach((defaultNavItem) => {
        //     //         if ( defaultNavItem.id === futuristicNavItem.id )
        //     //         {
        //     //             futuristicNavItem.children = cloneDeep(defaultNavItem.children);
        //     //         }
        //     //     });
        //     // });

        //     // Fill horizontal navigation children using the default navigation
        //     this._horizontalNavigation.forEach((horizontalNavItem) => {
        //         this._defaultNavigation.forEach((defaultNavItem) => {
        //             if ( defaultNavItem.id === horizontalNavItem.id )
        //             {
        //                 horizontalNavItem.children = cloneDeep(defaultNavItem.children);
        //             }
        //         });
        //     });

        //     // Return the response
        //     return [
        //         200,
        //         {
        //             compact   : cloneDeep(this._compactNavigation),
        //             default   : cloneDeep(this._defaultNavigation),
        //             futuristic: cloneDeep(this._futuristicNavigation),
        //             horizontal: cloneDeep(this._horizontalNavigation)
        //         }
        //     ];
        // });

    }
}
